import { allPresets } from "@/signomatic/app/sign_validator"
import { isTablet } from "@/common/util"
import storageLocal from "@/common/storage"

export const defaultToolbox = (signType: string, currentData: SignData | null) => {
  const presets = currentData ? allPresets(currentData) : null

  let nextToolbox = presets && presets.length > 0 ? "presets" : "size"

  if (["vinyl_text", "contour_cut"].includes(signType)) {
    nextToolbox = "text"
  } else if (["wood_sign", "label_plates"].includes(signType)) {
    nextToolbox = "presets"
  } else if (["meta_plastic_sign", "meta_name_sign"].includes(signType)) {
    nextToolbox = "production_type"
  } else if (["door_sign", "house_sign"].includes(signType)) {
    nextToolbox = "type"
  }

  return nextToolbox
}

export const autoOpenToolbox = (signType: string) => {
  if (isTablet()) {
    return false
  }

  const visitedSigns = JSON.parse(storageLocal.getItem("visitedSigns") || "[]")

  if (visitedSigns.includes(signType)) {
    return false
  }

  return ["wood_sign", "label_plates", "meta_plastic_sign", "meta_name_sign", "door_sign", "house_sign"].includes(
    signType
  )
}

export const setSignTypeVisited = (signType: string) => {
  const visitedSigns = JSON.parse(storageLocal.getItem("visitedSigns") || "[]")

  if (!visitedSigns.includes(signType)) {
    visitedSigns.push(signType)
  }

  storageLocal.setItem("visitedSigns", JSON.stringify(visitedSigns))
}
